import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { CdsContentPanel } from "clayco-component-library/lib";
import * as Icon from "react-bootstrap-icons";
import ManagementModal from "./management-modal";
import ApiProvider from "../../../apiProvider";
import { useMsal } from "@azure/msal-react";
import Spinner from "../shared/spinner";
import { ConfirmDlg } from "../shared/confirm-dlg";
import _ from "lodash";

const ManagementView = ({ setMenuOptions }) => {
    const { instance, accounts } = useMsal();
    const apiProvider = new ApiProvider(instance, accounts[0]);
    const [isEditMode, setIsEditMode] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showSpinner, setShowSpinner] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [modalData, setModalData] = useState({
        Author: "",
        CanEdit: [],
    });
    const [error, setError] = useState(null); // Add error state

    useEffect(() => {
        setMenuOptions("Skills");
        getManagementData();
    }, []);

    function addRow() {
        setShowModal(true);
    }

    function editRow(idx) {
        setIsEditMode(true);
        setModalData(_.cloneDeep(tableData[idx]));
        setShowModal(true);
    }

    function onCloseModal(reloadData) {
        setShowModal(false);
        setIsEditMode(false);
        setModalData({
            Author: "",
            CanEdit: [],
        });
        if (reloadData) {
            getManagementData();
            window.location.reload(); // I Cannot Think of a better way to refresh the Menu Builder, this works well enough for now
        }
    }

    async function getManagementData() {
        setShowSpinner(true);
        setError(null); // Reset error state

        try {
            const result = await apiProvider.Get(
                `OnBehalfOf`,
                null,
                "application/json",
                false
            );

            if (result && !result.error && result !== "" && result.length !== 0) {
                setTableData(result);
            } else if (result && !result.error && result.length === 0) {
                // No data returned, handle as empty state
                setTableData([]);
            } else {
                // API call failed, set error message
                setError("Failed to load management data. Please try again later.");
            }
        } catch (error) {
            // Handle unexpected errors
            setError("An unexpected error occurred. Please try again later.");
        } finally {
            setShowSpinner(false); // Ensure spinner is hidden after the API call
        }
    }

    function deleteRow(idx) {
        const prompt = async () => {
            if (
                await ConfirmDlg(
                    "Are you sure you want to delete this certificate?",
                    "Delete"
                )
            ) {
                // Make API call
                if (tableData[idx].employeeNumber) {
                    await apiProvider.Delete(
                        `OnBehalfOf/${tableData[idx].employeeNumber}`
                    );
                    await getManagementData(true);
                } else {
                    setTableData(tableData.filter((x, i) => i !== idx));
                }
            }
            window.location.reload(); // I Cannot Think of a better way to refresh the Menu Builder, this works well enough for now
        };

        prompt();

    }

    function ManagementReadonly() {
        return (
            <CdsContentPanel
                title="Manage On-Behalf-Of Permissions"
                primaryButtonText="Add new"
                primaryButtonSubmits={false}
                primaryButtonHandler={addRow}
            >
                {showSpinner ? (
                    <Row>
                        <Col>
                            <Spinner
                                show={showSpinner}
                                text="Loading Management Data..."
                            />
                        </Col>
                    </Row>
                ) : error ? ( // Render error message inside the CdsContentPanel
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            minHeight: "150px",
                            textAlign: "center",
                            color: "#B00020",
                            backgroundColor: "#FFF4F4",
                            borderRadius: "4px",
                            padding: "1rem",
                            fontWeight: "500",
                        }}
                    >
                        {error}
                    </div>
                ) : (
                    <table className="table table-striped table-container">
                        <thead className="table-light">
                            <tr>
                                <td style={{ width: "100px" }}></td>
                                <td scope="col-sm-12">Author</td>
                                <td scope="col-sm-12">Can Edit On-Behalf-Of</td>
                            </tr>
                        </thead>
                        {tableData?.map((item, idx) => (
                            <tbody key={`row-${idx}`}>
                                <tr>
                                    <td className="icons">
                                        <Icon.PencilFill
                                            className={"ms-0 icon text-primary"}
                                            key={`editPencil-${idx}`}
                                            onClick={() => editRow(idx)}
                                            role="button"
                                        />
                                        <Icon.TrashFill
                                            className="ms-3 icon text-primary"
                                            key={`delete-${idx}`}
                                            onClick={() => deleteRow(idx)}
                                            role="button"
                                        />
                                    </td>
                                    <td scope="row">{item.employeeName}</td>
                                    <td scope="row">
                                        {Object.values(item.users)
                                            .map((element) => element.employeeName)
                                            .join(", ")}
                                    </td>
                                </tr>
                            </tbody>
                        ))}
                    </table>
                )}
            </CdsContentPanel>
        );
    }

    return (
        <div className="skillsmanagement">
            <Row className="mb-4">
                <Col>
                    <ManagementReadonly />
                    {showModal && (
                        <ManagementModal
                            managementData={modalData}
                            setManagementData={setModalData}
                            show={showModal}
                            onCloseModal={onCloseModal}
                            isEditMode={isEditMode}
                        />
                    )}
                </Col>
            </Row>
        </div>
    );
};

export default ManagementView;
